module.exports = __webpack_public_path__ + "img/gonzalo-salse-byn.d6d02f09.jpg";